import { gql } from '@apollo/client';

export const CREATE_SCHOOL_TEST_DATAS = gql`
  mutation createSchoolTestDatas($inputs: [CreateTestPerformanceDataInput!]!) {
    tests: createSchoolTestDatas(inputs: $inputs) {
      id
    }
  }
`;
